import React from "react";
import { Button, Typography, Box } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";

const GoogleReviewCTA = ({ onClick, isDarkMode }) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      startIcon={<GoogleIcon />}
      sx={{
        justifyContent: "space-between",
        textTransform: "none",
        backgroundColor: isDarkMode ? "#2b2b2b" : "#ffffff",
        color: isDarkMode ? "#ffffff" : "#3c4043",
        border: `1px solid ${isDarkMode ? "#3c4043" : "#dadce0"}`,
        boxShadow: "0px 1px 2px rgba(0,0,0,0.12)",
        borderRadius: 4,
        padding: "10px 14px",
        "&:hover": {
          backgroundColor: isDarkMode ? "#333333" : "#f6f6f6",
          boxShadow: "0px 1px 2px rgba(0,0,0,0.16)",
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
          Leave Us A Google Review
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleReviewCTA;
